import ModalCute from "@/assets/images/dog-cute-not-supply.png"
import { appBorrowRepayPopupState, appSupplyWithdrawPopupState } from "@/atoms/appPopupState"
import useTrans from "@/hooks/useTrans"
import { Box, Typography } from "@mui/material"
import { useSetAtom } from "jotai"
import Image from "next/image"
import { FC } from "react"
import * as styles from "./styles"
import { BORROW, DEPOSIT } from "@/utils/constants"
import Button from "@/components/base/Button"

type EmptyRelendModalBodyProps = {
  title?: string
}

const EmptyRelendModalBody: FC<EmptyRelendModalBodyProps> = ({ title }) => {
  const trans = useTrans()
  const setBorrowRepayPopupState = useSetAtom(appBorrowRepayPopupState)
  const setSupplyWithdrawPopupState = useSetAtom(appSupplyWithdrawPopupState)

  const handleClick = () => {
    setBorrowRepayPopupState({
      isOpen: false,
      type: BORROW,
    })
    setSupplyWithdrawPopupState({
      isOpen: true,
      type: DEPOSIT,
    })
  }

  return (
    <Box sx={styles.modalEmptyWrapper} data-testid='empty-relend-modal-body'>
      <Image src={ModalCute} alt='hero-stat-icon' height={182} style={{ marginBottom: 16 }} />
      <Typography sx={styles.modalEmptyText} className='text-center'>
        {title ?? trans.dashboard.modal.no_supply_collateral}
      </Typography>
      <Button size='lg' fullWidth variant='primary' onClick={handleClick}>
        {trans.dashboard.modal.supply}
      </Button>
    </Box>
  )
}

export default EmptyRelendModalBody
